import { TranslocoDirective, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  providers: [provideTranslocoScope('tasks')],
  selector: 'task-product-edit-warning-dialog',
  imports: [MatButtonModule, MatDialogModule, TranslocoDirective],
  templateUrl: './task-product-edit-warning-dialog.html',
  styleUrl: './task-product-edit-warning-dialog.scss',
})
export class TaskProductEditWarningDialog {}
